import { Fragment, h } from '@stencil/core';
import cn from 'classnames';
import { send, documentDownloadEvent, isAnalyticsEnabled, parseCommonURLToRouterParts, getParamValueFromURL } from '@pes-ui/utils';
import { openPopupCenter } from '../../../../globals/utils/helpers';
import { validate } from '../../../runtime/utils';
import PesRoute from '../../../pes-router/pes-route';
import { isAppRoutingEnabled, navigateWithRouter } from '../../../pes-router/utils';
export class SpecificationsTable {
  generateUrl(productUrl) {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(productUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      return this.route.url;
    }
    return productUrl;
  }
  constructor() {
    this.onExternalLinkHandler = (link, event) => {
      var _a, _b;
      const documentId = getParamValueFromURL(link, 'p_Doc_Ref');
      const documentName = (_a = getParamValueFromURL(link, 'p_File_Name|p_Archive_Name')) !== null && _a !== void 0 ? _a : '';
      const documentType = (_b = getParamValueFromURL(link, 'p_enDocType')) !== null && _b !== void 0 ? _b : '';
      if (documentId) {
        send(documentDownloadEvent, { documentId, documentName, documentType });
      }
      else if (isAppRoutingEnabled()) {
        event.preventDefault();
        const { pageType, pageId } = parseCommonURLToRouterParts(link);
        const route = new PesRoute({ page: pageType, pageId });
        navigateWithRouter(route, event.currentTarget);
      }
    };
    this.handleRuntimeSubmit = (event) => {
      this.runtimeValue = event.detail;
    };
    this.runtimeInfo = undefined;
    this.data = undefined;
    this.runtimeValue = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b;
    this.runtimeValue = (_b = (_a = this.runtimeInfo) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.pwrRated;
  }
  isRuntimeError() {
    var _a;
    return Boolean(validate((_a = this.runtimeInfo) === null || _a === void 0 ? void 0 : _a.product, this.runtimeValue));
  }
  render() {
    var _a, _b, _c, _d, _e;
    return (h("table", { class: "specifications-table" }, h("caption", { class: "specifications-table__caption" }, this.data.tableName), h("tbody", null, this.runtimeInfo && (h(Fragment, null, h("tr", { class: "specifications-table__row" }, h("th", { class: "specifications-table__row-heading" }, h("pes-runtime-field", { onPesRuntimeDidSubmit: this.handleRuntimeSubmit, isError: this.isRuntimeError(), min: (_a = this.runtimeInfo.product) === null || _a === void 0 ? void 0 : _a.startPoint, max: (_b = this.runtimeInfo.product) === null || _b === void 0 ? void 0 : _b.pwrRated, labels: this.runtimeInfo.translations, defaultValue: String((_c = this.runtimeInfo.product) === null || _c === void 0 ? void 0 : _c.pwrRated) })), h("td", { class: "specifications-table__cell" }, h("pes-runtime-load-cell", { labels: this.runtimeInfo.translations, runtimeParams: this.runtimeInfo.product, value: this.runtimeValue }))), h("tr", { class: "specifications-table__row" }, h("th", { class: "specifications-table__row-heading" }, h("pes-runtime-heading-cell", { class: "specifications-table__max-capacity", tooltipText: this.runtimeInfo.translations.indicatesCapacity }, this.runtimeInfo.translations.maxCapacityUsed)), h("td", { class: "specifications-table__cell" }, h("pes-max-capacity-cell", { class: "specifications-table__max-capacity-bar", labels: this.runtimeInfo.translations, runtimeParams: this.runtimeInfo.product, value: this.runtimeValue }))))), (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.rows) === null || _e === void 0 ? void 0 :
      _e.map((row) => {
        var _a;
        return (h("tr", { class: "specifications-table__row" }, h("th", { class: "specifications-table__row-heading" }, row.characteristicName), h("td", { class: "specifications-table__cell" }, (_a = row.characteristicValues) === null || _a === void 0 ? void 0 : _a.map((detail) => [
          detail.beforeText && h("div", { innerHTML: detail.beforeText }),
          !detail.beforeText && detail.value && h("div", { innerHTML: detail.value }),
          detail.externalUrl ? (h("qds-standalone-link", { href: !detail.openPopup ? this.generateUrl(detail.externalUrl) : '#', class: "specifications-table__link", target: !detail.openPopup && (detail.displayLinkIcon ? '_blank' : '_self'), onClick: (e) => {
              if (detail.openPopup) {
                e.preventDefault();
                openPopupCenter({
                  url: detail.externalUrl,
                  title: '',
                });
              }
              isAnalyticsEnabled() && this.onExternalLinkHandler(detail.externalUrl, e);
            }, iconName: detail.displayLinkIcon
              ? "arrow-top-right-on-square"
              : "arrow-down-tray" }, h("span", { class: "specifications-table__link-text", innerHTML: detail.labelText }))) : (h("span", { class: cn('specifications-table__text', detail.needUpperCase
              && 'specifications-table__text--first-letter-uppercase'), innerHTML: detail.labelText })),
          detail.afterText && h("div", { innerHTML: detail.afterText }),
        ]))));
      }))));
  }
  static get is() { return "pes-specifications-table"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["specifications-table.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["specifications-table.css"]
    };
  }
  static get properties() {
    return {
      "runtimeInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeInfo",
          "resolved": "{ product: { id: string; } & TRuntimeAttributes; mainCategory: string; translations: TRuntimeTranslations; }",
          "references": {
            "TRuntimeInfo": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "data": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSpecificationTable",
          "resolved": "{ rows?: TSpecificationRow[]; tableName?: string; }",
          "references": {
            "TSpecificationTable": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "runtimeValue": {}
    };
  }
  static get elementRef() { return "el"; }
}
